const TestStore = {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    getList: state => state.list,
    getListItem: (state, getters) => itemId => state.list.find(item => item.id === itemId),
    getListItemProp: (state, getters) => (itemId, prop) => getters.getListItem(itemId)[prop],
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    addListItem(state, itemData) {
      state.list = [...state.list, itemData];
      // state.list.push(itemData); // doesn't work reactivity
    },
    deleteListItem(state, itemId) {
      state.list = state.list.filter(p => p.id !== itemId);
    },
    updateListItem(state, { id, updatedData }) {
      state.list = state.list.map(item => {
        if (item.id === id) {
          return { ...item, ...updatedData };
        }

        return item;
      });
    },
    updateListItemExistProp(state, { id, propData }) {
      const itemData = this.getters['test/getListItem'](id);

      // itemData.prop1.a = propData.text; // reactivity works
      itemData.prop2[0].b = propData.text; // reactivity works
      // itemData.prop1 = propData;
    },
    updateListItemNewProp(state, { id, data }) {
      // const itemData = this.getters['test/getListItem'](id);

      // itemData = { ...itemData, ...data }; // doesn't work reactivity
      // state.list[0] = { ...itemData, ...data }; // doesn't work reactivity

      // state.list = state.list.map(item => {
      //   if (item.id === id) {
      //     item = { ...item, ...data };
      //   }

      //   return item;
      // });

      // state.list.forEach((item, index) => {
      //   if (item.id === id) {
      //     state.list[index] = { ...item, ...data };
      //   }
      // });

      const index = state.list.findIndex(item => item.id === id);

      if (index !== -1) {
        state.list = [
          ...state.list.slice(0, index),
          { ...state.list[index], ...data },
          ...state.list.slice(index + 1),
        ];
      }
    },
  },
};

export default TestStore;
